/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum Operation {
  BEGINS_WITH = "BEGINS_WITH",
  CONTAINS = "CONTAINS",
  EQUAL = "EQUAL",
  NOT_CONTAINS = "NOT_CONTAINS",
  NOT_EQUAL = "NOT_EQUAL",
  NOT_EXISTS = "NOT_EXISTS",
}

export enum SubscriptionStatus {
  ACTIVE = "ACTIVE",
  NOT_ACTIVE = "NOT_ACTIVE",
}

export interface Criterion {
  property: string;
  operation: Operation;
  value?: any | null;
}

export interface QueryInput {
  hash: string;
  range?: string | null;
  criteria: Criterion[];
}

//==============================================================
// END Enums and Input Objects
//==============================================================
